$z-index-base: 0; // Base stacking level (0) — default in-flow content.
$z-index-dropdown: 1000; // Dropdown menus and select popups.
$z-index-sticky: 1100; // Sticky elements that pin on scroll (headers, toolbars).
$z-index-overlay: 1200; // Full-screen overlay scrims sitting behind modal content.
$z-index-modal: 1300; // Modal dialogs and side sheets.
$z-index-popover: 1400; // Popovers anchored to a trigger, above modals.
$z-index-toast: 1500; // Toast and snackbar notifications.
$z-index-tooltip: 1600; // Tooltips — the top-most interactive layer.
